//@ts-check
import React from "react";

const BlockWindow = () => {
    return <div className='block-window' />
}

export default BlockWindow;